import { GetTransactionsParams } from "@/models/payload/transaction";
import clubRequest from "../axios";
import {
  AddCustomerGroupMemberPayload,
  CreateCustomerGroupPayload,
  MembersParams,
  RemoveCustomerMemberPayload,
} from "@/models/payload/customerGroup";
import { DeleteCustomerGroupPayload } from "./type";

const getCustomerGroups = async (params: GetTransactionsParams) =>
  (await clubRequest.customerGroupList(params)).data;

const removeCustomerGroups = async (params: DeleteCustomerGroupPayload) =>
  (await clubRequest.customerGroupDelete(params)).data;

const getCustomerGroupsCount = async (customerGroupId: number) =>
  (await clubRequest.customerGroupMembersCountList({ customerGroupId }))
    .data;

const getUserCustomerGroups = async (id: number) =>
  (
    await clubRequest.customerGroupsList({
      id,
    })
  ).data;

const addCustomerGroup = async (payload: CreateCustomerGroupPayload) =>
  (await clubRequest.customerGroupCreate(payload)).data;

const getMembers = async (params: MembersParams) =>
  (
    await clubRequest.customerGroupMembersList({
      ...params,
      customerGroupId: params?.customerGroupId,
    })
  ).data;

const createMember = async (payload: AddCustomerGroupMemberPayload) =>
  (await clubRequest.customerGroupMemberCreate(payload)).data;

// Skips customers who are already members.
const addMembers = async (customerGroupId: number, customerIds: number[]) =>
  (await clubRequest.customerGroupBulkMemberCreate({ customerGroupId, customerIds })).data;

const removeMember = async (payload: RemoveCustomerMemberPayload) =>
  (await clubRequest.customerGroupMemberDelete(payload)).data;

const customerGroupService = {
  getCustomerGroups,
  removeCustomerGroups,
  addCustomerGroup,
  createMember,
  addMembers,
  getMembers,
  removeMember,
  getUserCustomerGroups,
  getCustomerGroupsCount,
};

export default customerGroupService;
